import CitySEOHead from "@/components/feature/CitySEOHead";
import MandevilleHeroSection from "./components/HeroSection";
import MandevilleStickyNav from "./components/StickyNav";
import MandevilleProcessingTimeSection from "./components/ProcessingTimeSection";
import MandevilleServicesSection from "./components/ServicesSection";
import MandevilleLocalAreaSection from "./components/LocalAreaSection";
import MandevilleTestimonialsSection from "./components/TestimonialsSection";
import MandevilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MandevilleComparisonSection from "./components/ComparisonSection";
import MandevilleMistakesSection from "./components/MistakesSection";
import MandevilleHowItWorksSection from "./components/HowItWorksSection";
import MandevilleFAQSection, { faqs } from "./components/FAQSection";
import MandevilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MandevilleFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import MandevilleTravelTimingSection from "./components/TravelTimingSection";
import MandevilleDestinationsSection from "./components/DestinationsSection";

export default function MandevillePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Mandeville"
        state="Louisiana"
        stateAbbr="LA"
        route="/mandeville"
        title="Emergency Passport Mandeville, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Mandeville, LA — as fast as 24 hours. Serving Northshore professionals, lakefront families, and St. Tammany Parish retirees. No Causeway required. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Mandeville, Louisiana"
        geoPosition="30.3577;-90.0843"
        faqs={faqs}
        servicesSchema={[
          { name: "Emergency Passport", description: "Urgent passport processing for Mandeville travelers with immediate departure needs — as fast as 24 hours for Northshore residents." },
          { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Mandeville with an expired or expiring passport." },
          { name: "New Passport", description: "First-time passport application assistance for Mandeville and St. Tammany Parish families." },
          { name: "Lost or Stolen Passport", description: "Passport replacement for lost or stolen passports with DS-64 form guidance in Mandeville, LA." },
          { name: "Child Passport", description: "Passport services for minors under 16 with parental consent guidance for Northshore families." },
          { name: "Name Change", description: "Passport correction and name change service for Mandeville residents after marriage or legal changes." },
          { name: "Second Passport", description: "Second passport service for Northshore professionals and frequent international travelers from Mandeville." },
        ]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <MandevilleHeroSection />
      <MandevilleStickyNav />
      <MandevilleProcessingTimeSection />
      <MandevilleLocalAreaSection />
      <MandevilleServicesSection />
      <MandevilleTravelTimingSection />
      <MandevilleDestinationsSection />
      <MandevilleTestimonialsSection />
      <MandevilleAcceptanceFacilitiesSection />
      <MandevilleComparisonSection />
      <MandevilleMistakesSection />
      <MandevilleHowItWorksSection />
      <MandevilleFAQSection />
      <MandevilleHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/mandeville" state="LA" />
      <MandevilleFinalCTA />
    </div>
  );
}